import { FC } from "react";

import { RydeUiUnit } from "@ryde/shared";

import { FeedbackExpand, RideProductionExpand } from "./parts";

interface IExpandEditFormFooterFlow {
  entity: RydeUiUnit;
  onSaveClick?: () => void;
}

export const ExpandEditFormFooterFlow: FC<IExpandEditFormFooterFlow> = ({
  entity,
  onSaveClick,
}) => {
  switch (entity) {
    case "feedback":
      return <FeedbackExpand entity={entity} onSaveClick={onSaveClick} />;
    case "rideProduction":
      return <RideProductionExpand />;

    default:
      return null;
  }
};
